module.exports = __webpack_public_path__ + "static/media/iceberg.d46212f6.webp";